(function() {
    var PatientLightbox = {
        lightboxElement : null,
        lightboxBackgroundElement : null,
        lightboxCloseElement : null,
        lightboxIndicatorsWrapperElement : null,
        lightboxIndicatorElements : [],
        lightboxControlElements : {
            prev : null,
            next : null
        },
        lightboxPatientInfoElements : {
            name : null,
            bio : null
        },
        lightboxBeforeImagesWrapperElement : null,
        lightboxBeforeImageElements : [],
        lightboxAfterImageWrapperElement : null,
        lightboxAfterImageElements : [],
        lightboxImageWrappers : [],

        isLightboxOpen : false,

        currentTrigger : null,
        activeIndex : 0,
        slides : [],
        isSwitching : false,

        changeActiveIndex : function(nextIndex) {
            if ( this.isSwitching || nextIndex == this.activeIndex ) {
                return;
            }
            this.isSwitching = true;
            var prevIndex = this.activeIndex;
            this.activeIndex = nextIndex;
            this.lightboxElement.classList.add('switching');
            this.lightboxIndicatorElements[prevIndex].classList.remove('active');
            this.lightboxIndicatorElements[this.activeIndex].classList.add('active');
            setTimeout(function() {
                this.lightboxElement.classList.add('resetting');
                this.lightboxBeforeImageElements[prevIndex].classList.remove('active');
                this.lightboxBeforeImageElements[this.activeIndex].classList.add('active');
                this.lightboxAfterImageElements[prevIndex].classList.remove('active');
                this.lightboxAfterImageElements[this.activeIndex].classList.add('active');
                requestAnimationFrame( function() {
                    this.lightboxElement.classList.remove('resetting');
                    requestAnimationFrame( function() {
                        this.lightboxElement.classList.remove('switching');
                        this.isSwitching = false;
                    }.bind(this));
                }.bind(this));
            }.bind(this), 750);
        },


        initializeLightbox : function() {
            this.activeIndex = 0;
            this.lightboxIndicatorsWrapperElement.innerHTML = "";
            this.lightboxIndicatorElements = [];
            this.lightboxBeforeImageElements = [];
            this.lightboxAfterImageElements = [];
            this.slides = [];
            for ( var p = 0; p < this.currentTrigger.patientBeforeImages.length; p++ ) {
                if ( this.currentTrigger.patientAfterImages[p] ) {
                    this.slides.push({ before : this.currentTrigger.patientBeforeImages[p], after : this.currentTrigger.patientAfterImages[p] });
                }
            }
            // Side-by-side composites (imported results): one image, before on the left half, after on the right.
            for ( var c = 0; c < this.currentTrigger.patientComposites.length; c++ ) {
                this.slides.push({ before : this.currentTrigger.patientComposites[c], after : this.currentTrigger.patientComposites[c], composite : true });
            }
            for ( var i = 0; i < this.slides.length; i++ ) {
                (function() {
                    var currentSlide = this.slides[i];
                    var currentBeforeImage = currentSlide.before;
                    var currentAfterImage = currentSlide.after;
                    var currentImageWrapper = document.createElement("div");
                    currentImageWrapper.classList.add('lightbox-image-wrapper');
                    if ( currentSlide.composite ) {
                        currentImageWrapper.classList.add('composite');
                    }

                    if ( this.currentTrigger.showBadges ) {
                        var beforeImageLabelWrapper = document.createElement('div');
                        beforeImageLabelWrapper.classList.add('lightbox-images-label-wrapper');
                        var beforeImageLabel = document.createElement('div');
                        beforeImageLabel.classList.add('lightbox-images-label');
                        beforeImageLabel.textContent = "Before";
                        beforeImageLabelWrapper.appendChild(beforeImageLabel);
                        currentImageWrapper.appendChild(beforeImageLabelWrapper);
                    }

                    currentImageWrapper.style.backgroundImage = "url(" + currentBeforeImage + ")";
                    if ( i == 0 ) {
                        currentImageWrapper.classList.add('active');
                    }

                    var currentAfterImageWrapper = currentImageWrapper.cloneNode();
                    currentAfterImageWrapper.style.backgroundImage = "url(" + currentAfterImage + ")";
                    if ( currentSlide.composite ) {
                        currentImageWrapper.style.backgroundPosition = "left center";
                        currentAfterImageWrapper.style.backgroundPosition = "right center";
                    }
                    if ( i == 0 ) {
                        currentAfterImageWrapper.classList.add('active');
                    }

                    if ( this.currentTrigger.showBadges ) {
                        var afterImageLabelWrapper = document.createElement('div');
                        afterImageLabelWrapper.classList.add('lightbox-images-label-wrapper');
                        var afterImageLabel = document.createElement('div');
                        afterImageLabel.classList.add('lightbox-images-label');
                        afterImageLabel.textContent = "After";
                        afterImageLabelWrapper.appendChild(afterImageLabel);
                        currentAfterImageWrapper.appendChild(afterImageLabelWrapper);
                    }

                    this.lightboxBeforeImageElements.push(currentImageWrapper);
                    this.lightboxBeforeImagesWrapperElement.appendChild(currentImageWrapper);
                    this.lightboxAfterImageElements.push(currentAfterImageWrapper);
                    this.lightboxAfterImagesWrapperElement.appendChild(currentAfterImageWrapper);
                    var lightboxIndicator = document.createElement('div');
                    lightboxIndicator.classList.add('lightbox-indicator')
                    if ( i == 0 ) {
                        lightboxIndicator.classList.add('active');
                    }
                    (function() {
                        var index = i;
                        lightboxIndicator.addEventListener('click', function() {
                            this.changeActiveIndex(index);
                        }.bind(this));
                    }.bind(this))();
                    this.lightboxIndicatorElements.push(lightboxIndicator);
                    this.lightboxIndicatorsWrapperElement.appendChild(lightboxIndicator);

                }.bind(this))();
            }
            if ( this.slides.length > 1 ) {
                this.lightboxElement.classList.add('has-multiple-images');
            } else {
                this.lightboxElement.classList.remove('has-multiple-images');
            }
        },

        openLightbox : function(currentTrigger) {
            if ( this.isLightboxOpen ) {
                return;
            }
            this.currentTrigger = currentTrigger;
            this.isSwitching = false;
            document.documentElement.classList.add('lightbox-is-open');
            this.initializeLightbox();
            this.isLightboxOpen = true;
            this.lightboxElement.classList.add('raised');

            this.lightboxPatientInfoElements.name.innerHTML = this.currentTrigger.patientName;
            this.lightboxPatientInfoElements.bio.innerHTML = this.currentTrigger.patientBio;
            if ( this.currentTrigger.videoLink != null && this.currentTrigger.videoLink != "") {
                this.lightboxPatientInfoElements.videoLink.classList.remove('hidden');
                this.lightboxPatientInfoElements.videoLink.href = this.currentTrigger.videoLink;
            } else {
                this.lightboxPatientInfoElements.videoLink.classList.add('hidden');
            }

            requestAnimationFrame(function() {
                this.lightboxElement.classList.add('open');
                setTimeout( function() {
                    this.lightboxElement.classList.add('showing');
                    setTimeout( function() {
                        this.lightboxElement.classList.add('settled');
                    }.bind(this), 500);
                }.bind(this), 750);
            }.bind(this));
        },

        closeLightbox : function() {
            if ( !this.isLightboxOpen ) {
                return;
            }
            document.documentElement.classList.remove('lightbox-is-open');
            this.lightboxElement.classList.remove('settled');
            this.lightboxElement.classList.remove('showing');

            setTimeout( function() {
                this.lightboxElement.classList.remove('open');
                
                setTimeout( function() {
                    this.isLightboxOpen = false;
                    this.lightboxElement.classList.remove('raised');
                    this.lightboxBeforeImagesWrapperElement.innerHTML = "";
                    this.lightboxAfterImagesWrapperElement.innerHTML = "";
                    if ( this.currentTrigger && this.currentTrigger.element ) {
                        this.currentTrigger.element.focus({ preventScroll : true });
                    }
                }.bind(this), 750);
            }.bind(this), 500);
        },

        addEventListeners : function() {
            this.lightboxCloseElement.addEventListener('click', this.closeLightbox.bind(this));
            this.lightboxBackgroundElement.addEventListener('click', this.closeLightbox.bind(this));

            this.lightboxControlElements.prev.addEventListener('click', this.showPrevious.bind(this));
            this.lightboxControlElements.next.addEventListener('click', this.showNext.bind(this));

            document.addEventListener('keydown', function(event) {
                if ( !this.isLightboxOpen ) {
                    return;
                }
                if ( event.key == 'Escape' ) {
                    this.closeLightbox();
                } else if ( event.key == 'ArrowLeft' && this.slides.length > 1 ) {
                    this.showPrevious();
                } else if ( event.key == 'ArrowRight' && this.slides.length > 1 ) {
                    this.showNext();
                }
            }.bind(this));
        },

        showPrevious : function() {
            this.changeActiveIndex(this.activeIndex == 0 ? this.slides.length - 1 : this.activeIndex - 1);
        },

        showNext : function() {
            this.changeActiveIndex(this.activeIndex == this.slides.length - 1 ? 0 : this.activeIndex + 1);
        },

        init : function() {
            this.lightboxElement = document.getElementById('patient-lightbox');
            this.lightboxCloseElement = this.lightboxElement.querySelector('.lightbox-close-button')
            this.lightboxBackgroundElement = this.lightboxElement.querySelector('.lightbox-background')
            this.lightboxBeforeImagesWrapperElement = this.lightboxElement.querySelector('.lightbox-before-images-wrapper')
            this.lightboxAfterImagesWrapperElement = this.lightboxElement.querySelector('.lightbox-after-images-wrapper')
            this.lightboxCloseElement = this.lightboxElement.querySelector('.lightbox-close-button')
            this.lightboxPatientInfoElements.name = this.lightboxElement.querySelector('.lightbox-patient-info-wrapper .patient-name');
            this.lightboxPatientInfoElements.bio = this.lightboxElement.querySelector('.lightbox-patient-info-wrapper .patient-bio');
            this.lightboxPatientInfoElements.videoLink = this.lightboxElement.querySelector('.lightbox-patient-info-wrapper .patient-video-link');
            this.lightboxIndicatorsWrapperElement = this.lightboxElement.querySelector('.lightbox-indicators-wrapper');
            this.lightboxControlElements.prev = this.lightboxElement.querySelector('.lightbox-control.prev');
            this.lightboxControlElements.next = this.lightboxElement.querySelector('.lightbox-control.next');
            this.addEventListeners();
        }
    };

    var PatientLightboxConfig = {
        lightboxTriggers : [],

        addEventListeners : function() {
            for ( var i = 0; i < this.lightboxTriggers.length; i++ ) {
                (function() {
                    var currentTrigger = this.lightboxTriggers[i];
                    currentTrigger.element.addEventListener('click', PatientLightbox.openLightbox.bind(PatientLightbox, currentTrigger));
                    currentTrigger.element.addEventListener('keydown', function(event) {
                        if ( event.key == 'Enter' || event.key == ' ' ) {
                            event.preventDefault();
                            PatientLightbox.openLightbox(currentTrigger);
                        }
                    });
                }.bind(this))();
            }
        },

        init : function() {
            var patientLightboxTriggerElements = document.querySelectorAll('[patient-lightbox-trigger]');
            for ( var i = 0; i < patientLightboxTriggerElements.length; i++ ) {
                var currentTriggerElement = patientLightboxTriggerElements[i];
                var patientBeforeImages = currentTriggerElement.getAttribute('patient-lightbox-before-images').split(',');
                patientBeforeImages = patientBeforeImages.filter(Boolean);
                var patientAfterImages = currentTriggerElement.getAttribute('patient-lightbox-after-images').split(',')
                patientAfterImages = patientAfterImages.filter(Boolean);
                this.lightboxTriggers.push({
                    element : currentTriggerElement,
                    patientBeforeImages : patientBeforeImages,
                    patientAfterImages : patientAfterImages,
                    patientComposites : (currentTriggerElement.getAttribute('patient-lightbox-composites') || '').split(',').filter(Boolean),
                    showBadges : currentTriggerElement.getAttribute('patient-lightbox-badges') === '1',
                    patientName : currentTriggerElement.getAttribute('patient-name'),
                    patientBio : currentTriggerElement.getAttribute('patient-bio'),
                    videoLink : currentTriggerElement.getAttribute('patient-video-link')
                });
            }
            this.addEventListeners();
        }
    }

    window.wghi.PatientLightboxConfig = PatientLightboxConfig;
    window.wghi.PatientLightbox = PatientLightbox;

    document.addEventListener('DOMContentLoaded', function() {
        window.wghi.PatientLightboxConfig.init();
        window.wghi.PatientLightbox.init();
    });
})();